import api from './api';

export const getActiveTicketStatuses = async () => {
  const response = await api.get('/api/private/ticket-status');
  return response.data;
};

export const getAdminTicketStatuses = async () => {
  const response = await api.get('/api/private/ticket-status/admin', {
    params: { includeInactive: true },
  });
  return response.data;
};

export const createTicketStatus = async (payload) => {
  const response = await api.post('/api/private/ticket-status', payload);
  return response.data;
};

export const updateTicketStatus = async (id, payload) => {
  const response = await api.put(`/api/private/ticket-status/${id}`, payload);
  return response.data;
};

export const deleteTicketStatus = async (id) => {
  await api.delete(`/api/private/ticket-status/${id}`);
};
